import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Input, Button, Spin, Select } from 'antd';
import { AuthWrapper } from '../../style';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { pushKyc } from '../../../../../../redux/authentication/actionCreator';
import ReactGA from 'react-ga';
import api from '../../../../../../redux/authentication/api';
import e from 'cors';
import './ButtonStyles.scss';

function EKYCSigninPreProcess() {
  const dispatch = useDispatch();
  const msisdn = useSelector(state => state.auth.dataForm.msisdn);
  const isLoading = useSelector(state => state.auth.loading);
  const [form] = Form.useForm();
  const url = window.location.href;
  //const url="https://kongsi-portal-dev.s3-website-ap-southeast-1.amazonaws.com/signup";
  const CALL_BACK_API_URL = process.env.REACT_APP_CALL_BACK_API_URL;

  const handleSubmit = values => {
    ReactGA.event({ category: 'Kongsi Klub ekyc Push', action: 'Enter Details' });
    const params = {
      msisdn: msisdn,
      email: values.email,
      type: 'RECRUITER',
      age: values.age,
      callbackUrl: CALL_BACK_API_URL,
      successUrl: url,
      errorUrl: url,
    };
    dispatch(pushKyc(params, true));
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="register" onFinish={handleSubmit} layout="vertical" form={form}>
          <Heading as="h5">
            Daftar untuk &nbsp;
            <img style={{ width: '108px', height: '54px', borderRadius: '10px' }} src="images/nav-logo.png" />
          </Heading>
          <Form.Item
            name="email"
            label="Alamat e-mel berdaftar anda"
            rules={[
              { required: true, message: 'Emel diperlukan' },
              { type: 'email', message: 'Sila isikan emel yang sah' },
            ]}
          >
            <Input type="email" placeholder="username@email.com" />
          </Form.Item>
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: 'Sila sahkan kata laluan!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || msisdn.substring(msisdn.length - 4, msisdn.length) === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Input Tidak Sah');
                },
              }),
            ]}
            label="4 digit terakhir nombor telefon anda"
          >
            <Input type="number" placeholder="1234" />
          </Form.Item>

          <Form.Item
            name="age"
            rules={[
              { message: 'Umur mestilah melebihi 18 tahun', required: true },
              { pattern: /^(1[8-9]|[2-9][0-9])$/, message: 'Sumur mestilah melebihi 18 tahun' },
            ]}
            label="Umur"
          >
            <Input type="text" placeholder="Umur minimum ialah 18" />
          </Form.Item>

          <Form.Item>
            <Button className="btn-create" htmlType="submit" type="primary" size="large" disabled={isLoading}>
              Mulakan Pengesahan
            </Button>
          </Form.Item>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default EKYCSigninPreProcess;
